/**
 * Weebly
 *
 * Generates affiliate links for weebly.
 */

export function affiliateLink(domain: string): string {
  return `https://www.siteground.com/shared/step3.htm?domain=${domain}.com&p=1&afcode=f017a7f5a1821caa5c032ef5faab2040`;
}


// WEBPACK FOOTER //
// ./src/service/weebly.ts